import { render, staticRenderFns } from "./PrivateAreaTablePane.vue?vue&type=template&id=7efdbd9b&scoped=true"
import script from "./PrivateAreaTablePane.vue?vue&type=script&lang=js"
export * from "./PrivateAreaTablePane.vue?vue&type=script&lang=js"
import style0 from "./PrivateAreaTablePane.vue?vue&type=style&index=0&id=7efdbd9b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efdbd9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7efdbd9b')) {
      api.createRecord('7efdbd9b', component.options)
    } else {
      api.reload('7efdbd9b', component.options)
    }
    module.hot.accept("./PrivateAreaTablePane.vue?vue&type=template&id=7efdbd9b&scoped=true", function () {
      api.rerender('7efdbd9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/PrivateArea/PrivateAreaTablePane.vue"
export default component.exports